module.exports = __webpack_public_path__ + "static/media/score_icon.14b516f4.png";